import React, { useState, useEffect, useRef } from 'react';
import styled, { keyframes } from 'styled-components';
import { FaPlus, FaTrash } from 'react-icons/fa'; // Import plus and trash icons from react-icons/fa
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'
import noTypeImg from '../media/noType.gif'
import noNameImg from '../media/noName.png'
import noProjects from '../media/0.png'
import arrowImg from '../media/arrow3.png'
import LockIcon from '@mui/icons-material/Lock';
import CustomSelect from './CustomSelect';
import { updateProjects } from '../Redux/projectsSlice';
import { db } from '../firebase';
import { doc, serverTimestamp, updateDoc } from 'firebase/firestore';
import CustomSelectUpdates from './CustomSelectUpdates';
import { ensureFullURL, isValidURL, isValidURL_adv } from '../utils';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';



const Projects = ({ listn }) => {
  const [projects, setProjects] = useState([]);
  const [showModal, setShowModal] = useState(false); // State to control the visibility of the modal
  const [newProjectName, setNewProjectName] = useState('');
  const [selectedType, setSelectedType] = useState(''); // Default selected type
  const [compUrls, setCompUrls] = useState('');
  const [profileUrl, setProfileUrl] = useState('');
  const [siteReportUrl, setSiteReportUrl] = useState('');
  const [noSiteReportUrl, setNoSiteReportUrl] = useState(false);
  const [selectedUpdateInterval, setSelectedUpdateInterval] = useState('')
  const [isNoType, setIsNoType] = useState(false);
  const [isNoName, setIsNoName] = useState(false);
  const [noSelectedUpdateInterval, setNoSelectedUpdateInterval] = useState(false)
  const [isVAlidUrlx, setIsValidUrl] = useState(true)

  const gProjects = useSelector(state=> state.projects.projects)
  const dispatch = useDispatch()

  const user = useSelector(state=> state.user.user)

  const allProjects = [...gProjects]
  

  const inputRef = useRef(null); // Reference to the input element

  useEffect(()=> {
    if(user) setProjects(user.projects)
  }, [user])



  const regex = /^[a-zA-Z0-9\s]*$/
  // Function to add a new project
  // const addProjectToState = async () => {
  //   // Add the new project to the list of projects
  //   if(newProjectName.trim() !== '' && selectedType !== '') {
  //     if(regex.test(newProjectName.trim())) {

        
  //       if(selectedType === 'competition' && compUrls === '') return

  //       const sameName = gProjects.find(x=> x.name.toLocaleLowerCase() === newProjectName.trim().toLowerCase() && x.type === selectedType)

  //       if(sameName) {
  //         return window.alert("You've already created a project with the same name and type! Please choose a different name or type for your new project.")
          
  //       }


  //       let updatedProjects


  //       if(selectedType === 'keyword') {
  //         updatedProjects = [...allProjects, { name: newProjectName.trim(), type: selectedType, themes: [], n: projects.length + 1 }]
  //       }
  //       if(selectedType === 'site-report' && siteReportUrl.trim() !== '' && selectedUpdateInterval !== '') {
  //         setNoSiteReportUrl(false)
  //         setNoSelectedUpdateInterval(false)
  //         setIsValidUrl(true)
  //         if(!isValidURL(siteReportUrl)) {
  //           setIsValidUrl(false)
  //           return
  //         }
  //         updatedProjects = [...allProjects, { name: newProjectName.trim(), type: selectedType, url: siteReportUrl, data: {}, lastUpdated: new Date().toUTCString(), selectedInterval: selectedUpdateInterval, n: projects.length + 1 }]
  //       } else {
  //         if(siteReportUrl.trim() === '') setNoSiteReportUrl(true)
  //         if(selectedUpdateInterval.trim() === '') setNoSelectedUpdateInterval(true)
  //         return
  //       }
  //       if(selectedType === 'competition') {
  //         let arr0 = compUrls
  //         let arr = arr0.split(',')
  //         let cleanData0 = arr.map(element => element.trim())
  //         let cleanData = cleanData0.slice(0, 5)
  //         updatedProjects = [...allProjects, { name: newProjectName.trim(), type: selectedType, urls: cleanData, data: [], lastUpdated: new Date().toUTCString(), n: projects.length + 1 }]
  //       }
  //       if(selectedType === 'backlink-profile' && profileUrl !== '') updatedProjects = [...allProjects, { name: newProjectName.trim(), type: selectedType, url: profileUrl, data: [], lastUpdated: new Date().toUTCString(), n: projects.length + 1 }]
        
  //       dispatch(updateProjects(updatedProjects))

  //       const userRef = doc(db, 'users', user.id)

  //       updateDoc(userRef, {projects: updatedProjects})   
        
        
  //       setProjects(updatedProjects);
  //       setNewProjectName('');
  //       setSelectedType('')
  //       setCompUrls('')
  //       setProfileUrl('')
  //       setShowModal(false);
  //       setIsNoName(false)
  //       setIsNoType(false)

  //       listn()

  //     } else {
  //       alert('Only letters, numbers and spaces allowed')
  //     }
  //   } else {
  //     if(newProjectName.trim() === '') {
  //       setIsNoName(true)
  //     } else if(selectedType === '') {
  //      setIsNoType(true)
  //     }
  //   }
  // };


  const addProjectToState = async () => {
    const trimmedProjectName = newProjectName.trim();
  
    if (trimmedProjectName === '' || selectedType === '') {
      if (trimmedProjectName === '') setIsNoName(true);
      if (selectedType === '') setIsNoType(true);
      return;
    }
  
    if (!regex.test(trimmedProjectName)) {
      alert('Only letters, numbers, and spaces allowed');
      return;
    }
  
    if (selectedType === 'competition' && compUrls === '') return;
  
    const sameName = gProjects.find(
      (x) =>
        x.name.toLowerCase() === trimmedProjectName.toLowerCase() && x.type === selectedType
    );
    if (sameName) {
      alert("You've already created a project with the same name and type! Please choose a different name or type for your new project.");
      return;
    }
  
    let newProject;
    const projectCommonData = {
      name: trimmedProjectName,
      type: selectedType,
      n: sortedProjs.length + 1,
      lastUpdated: new Date().toUTCString(),
    };
  
    switch (selectedType) {
      case 'keyword':
        newProject = { ...projectCommonData, themes: [] };
        break;
      case 'site-report':
        if (siteReportUrl.trim() === '' || selectedUpdateInterval === '') {
          if (siteReportUrl.trim() === '') setNoSiteReportUrl(true);
          if (selectedUpdateInterval === '') setNoSelectedUpdateInterval(true);
          return;
        }
        setNoSiteReportUrl(false);
        setNoSelectedUpdateInterval(false);
        if (!isValidURL_adv(siteReportUrl)) {
          setNoSiteReportUrl(true)
          return;
        }
        setNoSiteReportUrl(false)
        setIsValidUrl(true);
        newProject = {
          ...projectCommonData,
          url: ensureFullURL(siteReportUrl),
          data: {},
          selectedInterval: selectedUpdateInterval,
        };
        break;
      case 'competition':
        const urls = compUrls.split(',').map((url) => url.trim()).slice(0, 5);
        newProject = { ...projectCommonData, urls, data: [] };
        break;
      case 'backlink-profile':
        if (profileUrl === '') return;
        newProject = { ...projectCommonData, url: profileUrl, data: [] };
        break;
      case 'content-ideas':
        newProject = { ...projectCommonData, data: [] };
        break;
      default:
        return;
    }
  
    const updatedProjects = [...allProjects, newProject];
  
    setShowModal(false);
    setNewProjectName('');
    setSelectedType('');
    setCompUrls('');
    setProfileUrl('');
    setIsNoName(false);
    setIsNoType(false);
  
    dispatch(updateProjects(updatedProjects));
    const userRef = doc(db, 'users', user.id);
    await updateDoc(userRef, { projects: updatedProjects });
  
    setProjects(updatedProjects);
  
    // listn();
  };
  
  


  const sortedProjs = allProjects ? [...allProjects].sort((a, b) => a.n - b.n) : null;


  // Function to delete a project
  const deleteProject = (e, index) => {
    e.stopPropagation()
    e.preventDefault()
    const confirmation = window.confirm('Are you sure you want to delete this project? This action cannot be undone.');
    if (confirmation) {
      let updatedProjects = [...sortedProjs];
      updatedProjects.splice(index, 1);
      setProjects(updatedProjects);

      dispatch(updateProjects(updatedProjects))

      // listn()
    }
  };



  const handleCancelBtn = () => {
    setShowModal(false)
    setIsNoType(false)
    setIsNoName(false)
    setNewProjectName('')
    setSelectedType('')
    setCompUrls('')
    setNoSiteReportUrl(false)
    setNoSelectedUpdateInterval(false)
    setIsValidUrl(true)
  }


  // Handle pressing the Enter key in the input field
  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      addProjectToState();
    }
  };

  // Focus on the input field when the modal opens
  useEffect(() => {
    if (showModal) {
      inputRef.current.focus();
    }
  }, [showModal]);


  const linkStyles = {
    textDecoration: 'none',
    color: 'black'
  }


  return (
    <Container>
      <Header>
        <h1>Projects 
          {gProjects?.length < 5 && !user?.prem && <span style={{color: 'dodgerblue'}}>You have {5 - gProjects?.length} projects remaining. <span onClick={()=> window.location.href = '/pricing'}>Upgrade now to unlock unlimited projects and more features!</span></span>}
          {gProjects?.length >= 5 && !user?.prem && <span style={{color: 'var(--cntnt-color)'}}>You've reached your project limit. Delete a project or <span onClick={()=> window.location.href = '/pricing'}>upgrade now to create more projects and unlock additional features!</span></span>}
          </h1>
        {!user?.prem && gProjects?.length < 5 && <AddProjectButton onClick={() => setShowModal(true)}>
          <FaPlus /> Create Project
        </AddProjectButton>}
        {user?.prem && <AddProjectButton onClick={() => setShowModal(true)}>
          <FaPlus /> Create Project
        </AddProjectButton>}
      </Header>
      
      <ProjectList progs={projects.length}>
        {projects?.length !== 0 && <ProjectRowHeader>
        <ProjectName style={{fontSize: 'small', color: 'gray'}}>Projects</ProjectName>
        <ProjectType style={{fontSize: 'small', color: 'gray'}}>Project Type</ProjectType>
        <DeleteButton style={{width: '15px'}}></DeleteButton>
      </ProjectRowHeader>}

        {sortedProjs?.reverse().map((project, index) => {
          if(project.type === 'site-report') return
          return (
          <Link to={`/projects/${project.type === 'keyword'? 'kp': project.type === 'competition'? 'cp': project.type === 'backlink-profile'? 'bpp': project.type === 'site-report'? 'srp': project.type === 'content-ideas'? 'ci': 'ls'}?=${project.name.toLowerCase()}`} style={linkStyles}><ProjectRow key={index}>
            <ProjectName>{project.name}</ProjectName>
            <ProjectType style={{color: project.type.toLowerCase() === 'keyword'? 'dodgerblue': project.type.toLowerCase() === 'site-report'? 'slategray': project.type === 'content-ideas'? 'var(--cntnt-color)': 'green'}}>{project.type.replaceAll('-', ' ')} Project</ProjectType>
            <DeleteButton onClick={(e) => deleteProject(e, index)}>
              <FaTrash />
            </DeleteButton>
          </ProjectRow></Link>
        )
        })}
        {allProjects.length === 0 && <NoProjects>
          <p>No projects here yet, but the stage is set for your next creative breakthrough! <img src={arrowImg} /></p>
          <img src={noProjects} />
          </NoProjects>}
      </ProjectList>
      {showModal && (
        <div style={{display: 'flex'}}>
        <ModalContainer>
          <ModalContent>
            <h2>Create Project</h2>
            <>
            <input
              type="text"
              value={newProjectName}
              onChange={(e) => setNewProjectName(e.target.value)}
              onKeyPress={handleKeyPress} // Handle key press
              placeholder="Enter project name"
              ref={inputRef} // Set ref to input element
              style={{outline: 'none', position: 'relative', border: (isNoName && newProjectName.trim() === '')? '1px solid red': '', marginTop: '20px'}}
            />
            <span style={{display: 'block', marginBottom: '50px', marginLeft: '5px', color: (regex.test(newProjectName.trim()) && newProjectName.trim() !== '')? 'green': newProjectName.trim() ==='' ? 'black': 'red'}}>Only letters, numbers and spaces allowed</span>
            {/* {isNoName && newProjectName.trim() === '' && <span style={{position: 'absolute', color: 'white', transform: 'translatex(-260%)', transform: 'translatey(-1300%)'}}>Oops! Looks like you forgot to name your project! Just like in the '<span style={{color: 'cyan'}}>Art of Projects</span>' every great creation starts with a name!</span>}
            {isNoName && newProjectName.trim() === '' && <img src={noNameImg} width='350px' style={{position: 'absolute', left: '160px', transform: 'translatey(-90%)', maskImage: 'linear-gradient(to bottom, transparent, white, white, transparent'}}/>} */}
            </>
            {/* <SelectType
              value={selectedType}
              onChange={(e) => setSelectedType(e.target.value)}
              style={{position: 'relative', border: (isNoType && selectedType === '')? '1px solid red': ''}}
            >
              <option value="">Select Project Type</option>
              <option value="keyword">Keyword Project</option>
              <option value="">Competition Project <span style={{color: 'orange'}}> - Experimental <LockIcon /></span></option>
              <option value="">Backlink Profile Project <span style={{color: 'orange'}}> - Experimental <LockIcon /></span></option>
            </SelectType> */}
            <CustomSelect
                selectedType={selectedType}
                setSelectedType={setSelectedType}
                isNoType={isNoType}
              />
            <div style={{marginBlock: '20px'}}/>
            
            {selectedType === 'site-report' && <input className='profile_url' type='url' required value={siteReportUrl} onChange={e=> setSiteReportUrl(e.target.value)} placeholder='Enter website URL...' style={noSiteReportUrl? {borderColor: 'red'}: {}}/>}
            {selectedType === 'backlink-profile' && <input className='profile_url' type='url' required value={profileUrl} onChange={e=> setProfileUrl(e.target.value)} placeholder='Enter url to generate link profile...'/>}
            {selectedType === 'competition' &&<Competitors>
              <StyledTextarea rows={6} placeholder='competitor 1, competitor 2, ...' value={compUrls} onChange={(e=> setCompUrls(e.target.value))} required/>
              <Label>Enter the URLs of pages you want to compete with (up to five), <p style={{color: 'red'}}>separated with commas</p></Label>
            </Competitors>}
            <div style={{marginBlock: '10px'}}/>
            {selectedType === 'site-report' && <CustomSelectUpdates
                selectedType={selectedUpdateInterval}
                setSelectedType={setSelectedUpdateInterval}
                noSelectedUpdateInterval={noSelectedUpdateInterval}
            />}
            {/* {isNoType && selectedType === '' && <img src={noTypeImg} width='350px' style={{position: 'absolute', maskImage: 'linear-gradient(to bottom, transparent, white, white, transparent)'}}/>}
            {isNoType && selectedType === '' && <span style={{position: 'absolute', marginLeft: '30px', fontWeight: '300', color: 'white', fontSize: 'larger'}}>What is the type of your <span style={{color: 'aqua'}}>project</span>?!</span>} */}
            <div style={{marginBlock: '30px'}}/>

            <Button onClick={addProjectToState}>Create Project</Button>
            <CancelButton onClick={handleCancelBtn}>Cancel</CancelButton>
            <Docs onClick={()=> window.open('https://improwth.com/market-lab/docs', '_blank')}>Learn more about projects in the docs<OpenInNewIcon /></Docs>
          </ModalContent>
        </ModalContainer>

        {isNoType && <NoType></NoType>}
        </div>
      )}
    </Container>
  );
};


const Container = styled.div`
  padding: 20px;
  width: 78.5%;
  max-width: 1200px;
  margin: 0 auto;
  background-color: #f2f2f2;
`;


const fadeInAnimation = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`


const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  > h1 {
    font-weight: 300;
    width: fit-content;

    > span {
      font-size: medium;
      font-family: 'Quicksand';
      margin-left: 20px;

      > span {
        font-size: medium;
        font-family: 'Quicksand';
        cursor: pointer;
        transition: color 0.3s ease-in-out;

        &:hover {
          color: blue;
        }
      }
    }
  }
`;

const ProjectList = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 60px;
  overflow-x: hidden;
  overflow-y: ${props=> props.progs === 0? 'hidden': 'auto'};
  max-height: 500px;
`;

const ProjectRowHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  background-color: #f0f0f0;
  border-radius: 4px;
  margin-bottom: 5px;
  border-bottom: 1px solid rgb(230, 230, 230);
  transition: background-color 0.3s ease-in-out;


  opacity: 0;
  animation: ${fadeInAnimation} 1s ease-in-out forwards;
`;


const ProjectRow = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  background-color: #f0f0f0;
  border-radius: 4px;
  margin-bottom: 5px;
  border-bottom: 1px solid rgb(230, 230, 230);
  transition: background-color 0.3s ease-in-out;

  &:hover {
    background-color: hsl(0, 0%, 89%);
  }

  opacity: 0;
  animation: ${fadeInAnimation} 1s ease-in-out forwards;
`;

const ProjectName = styled.div`
  flex: 1;
`;

const ProjectType = styled.div`
  margin-right: 150px;
  width: 300px;
  text-transform: capitalize;
`;

const DeleteButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: #777;
  transition: color 0.3s;


  &:hover {
    color: #ff0000;
  }
`;

const AddProjectButton = styled.button`
  padding: 10px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;

  svg {
    margin-right: 5px;
  }

  &:hover {
    background-color: #0056b3;
  }
`;

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;

  animation: ${fadeInAnimation} 0.3s ease-in-out forwards;
`;

const ModalContent = styled.div`
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);

  > h2 {
    font-family: 'Lexend';
    font-weight: 200;
  }

  > input {
    width: 100%;
    padding: 10px;
    margin-bottom: 10px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    font-weight: 100;
    font-family: 'Crimson Text';
  }
`;

const SelectType = styled.select`
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
`;

const Button = styled.button`
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 10px;

  &:hover {
    background-color: #0056b3;
  }
`;

const CancelButton = styled(Button)`
  background-color: #ff6767;

  &:hover {
    background-color: #d13030;
  }
`;


const NoType = styled.div`
  color: red;
`

const NoProjects = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 78.5%;
  margin-left: 50px;
  overflow: none !important;

  opacity: 0;
  animation: ${fadeInAnimation} 0.2s ease-in-out forwards;

  > img {
    width: 35%;
    margin-bottom: 260px;
    filter: grayscale(50);
    opacity: 0.3;
  }

  > p {
    margin-bottom: 00px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  > p > img {
    width: 130px;
    /* filter: grayscale(90%); */
    rotate: -150deg;
    margin-left: 50px;
    opacity: 0.2;
    margin-top: 20px;
  }
`

const Competitors = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`

const Label = styled.label`
  font-size: 14px;
  margin-bottom: 5px;
`;

const StyledTextarea = styled.textarea`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  resize: none;
  outline: none;
  margin-top: 10px;
  
  opacity: 0;
  animation: ${fadeInAnimation} 1s ease-in-out forwards;

  &::placeholder {
    color: #bebebe; 
  }
`;


const Docs = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: auto;
  border: none;
  color: dodgerblue;
  transition: color 0.3s ease-in-out;
  cursor: pointer;
  margin-top: 20px;
  gap: 5px;

  &:hover {
    color: darkblue;
  }
`

export default Projects;
